<template>
  <div class="flex justify-between">
    <div class="flex items-center gap-1">
      <CardActionButton
        icon="outline_fire"
        :count="reactions[ReactionType.Fire]?.count || 0"
        :title="$t('common.likes')"
        :is-active="reactions[ReactionType.Fire]?.is_set_by_user"
        :is-processing="isCountersProcessing"
        @click="onChangeReaction(ReactionType.Fire)"
      />
      <template v-if="comments !== undefined">
        <template v-if="commentsRoute">
          <BaseLocaleLink :to="commentsRoute" class="flex no-underline">
            <CardActionButton
              icon="outline_chat_bubble"
              :count="comments"
              :title="$t('common.comments')"
            />
          </BaseLocaleLink>
        </template>
        <template v-else>
          <CardActionButton
            icon="outline_chat_bubble"
            class="pointer-events-none"
            :count="comments"
            :title="$t('common.comments')"
          />
        </template>
      </template>
      <CardActionButton
        icon="outline_share"
        :title="$t('common.share')"
        @click="openShareModal"
      />
    </div>
    <slot />
    <ShareModal
      :is-open="isShareModalOpen"
      :share-options="shareOptions"
      :link="pageLink"
      @close="closeShareModal"
    />
  </div>
</template>

<script setup lang="ts">
import type { RouteLocationRaw } from 'vue-router'
import { ReactionType } from '~/models/counters'
import type { ReactionsCounters } from '~/models/counters'
import {
  getTelegramLink,
  getTwitterLink,
  getFacebookLink,
  getLinkedinLink,
  getWhatsappLink,
} from '~/utils/share-constructor'

interface PropsInterface {
  name: string
  comments?: number
  reactions: ReactionsCounters
  pageLink: string
  isCountersProcessing: boolean
  route?: RouteLocationRaw
}

const props = defineProps<PropsInterface>()

const emit = defineEmits(['change-reaction'])

const isShareModalOpen = ref(false)

const openShareModal = () => {
  isShareModalOpen.value = true
}

const closeShareModal = () => {
  isShareModalOpen.value = false
}

const commentsRoute = computed(() => {
  if (typeof props.route === 'object') {
    return {
      ...props.route,
      ...{
        query: {
          scroll: 'comments',
        },
      },
    }
  }
  return props.route
})

const shareOptions = computed(() => [
  {
    icon: 'brand_facebook_circle_color',
    link: getFacebookLink(props.pageLink),
  },
  {
    icon: 'brand_twitter_circle_color',
    link: getTwitterLink(props.pageLink),
  },
  {
    icon: 'brand_linkedin_circle_color',
    link: getLinkedinLink(props.pageLink),
  },
  {
    icon: 'brand_telegram_circle_color',
    link: getTelegramLink(props.pageLink, props.name),
  },
  {
    icon: 'brand_whatsapp_circle_color',
    link: getWhatsappLink(props.pageLink, props.name),
  },
])

const onChangeReaction = (reactionType: ReactionType) => {
  emit('change-reaction', reactionType)
}
</script>
